<template lang="pug">
    section#condicoes
        .wrapper
            h2 Quais as condições para garantir a minha bolsa?
            ul
                li
                    img(:src="require('@images/icones/Bolsas/desk.png')")
                    p
                        |Ter concluído o Ensino Médio.
                li
                    img(:src="require('@images/icones/Bolsas/training.png')")
                    p
                        |Realizar a matrícula em uma Unidade UniFAEL e verificar disponibilidade de bolsas na mesma.
                li
                    img(:src="require('@images/icones/Bolsas/economia.png')")
                    p
                        |Não estar cadastrado em programas com outros benefícios de Bolsa de Desconto.
</template>

<script>
export default {
    name: "section-condicoes"
}
</script>

<style lang="stylus" scoped src="./Condicoes.styl"></style>
